import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

const VeraLabel = styled.div`
  display: inline-block;
  border-radius: 4px;
  width: 32px;
  height: 25px;
  text-align: center;
  line-height: 24px;
  color: white;
`;

VeraLabel.displayName = 'VeraLabel';

export default VeraLabel;
